'use client';

import type { ReactElement } from 'react';
import { useState } from 'react';
import { useAppSelector } from 'lib/hooks';
import { selectCartCount } from 'slices/selectors';
import CartIcon from 'components/icons/CartIcon';
import UIButton from 'components/buttons/UIButton';

export default function CartButton(): ReactElement | null {
  const cartCount = useAppSelector(selectCartCount);
  const [prevCartCount, setPrevCartCount] = useState(cartCount);
  const [bouncing, setBouncing] = useState(false);

  if (cartCount !== prevCartCount) {
    setPrevCartCount(cartCount);
    setBouncing(true);
  }

  return (
    <UIButton
      buttonType="text"
      className="cart-btn"
      href="/cart"
      label="Cart"
      iconPosition="left"
      icon={
        <span className="cart-icon-wrapper">
          <CartIcon />
          {cartCount > 0 && (
            <div
              className={`cart-count-badge${bouncing ? ' bounce' : ''}`}
              onAnimationEnd={() => setBouncing(false)}
            >
              {cartCount}
            </div>
          )}
        </span>
      }
    />
  );
}
